<template>
    <div class="swiper-container" ref="container">
        <slot></slot>
    </div>
</template>

<script>
    // We need to explicitly import swiper from the UMD file, as otherwise it won't work on IE11
    // https://github.com/nolimits4web/Swiper/issues/2237
    import Swiper from 'swiper/js/swiper.js';

    export default {
        name: 'Swiper',
        props: {
            direction: {type: String, default: 'horizontal'},
            mousewheel: {type: Boolean, default: false},
            keyboard: {
                type: Object, default: () => ({
                    enabled: false,
                })
            },
            preventClicks: {type: Boolean, default: true},
            preventClicksPropagation: {type: Boolean, default: false},
            preloadImages: {type: Boolean, default: false},
            lazy: {type: Object, default: () => ({loadPrevNext: true})},
            autoplay: {default: () => ({})},
            slidesPerView: {default: 1},
            slidesPerGroup: {type: Number, default: 1},
            speed: {type: Number, default: 400},
            loop: {type: Boolean, default: true},
            initialSlide: {type: Number, default: 0},
            roundLengths: {type: Boolean, default: false},
            spaceBetween: {type: Number, default: 0},
            navigation: {type: Object, default: () => ({})},
            pagination: {default: () => ({})},
            breakpoints: {type: Object, default: () => ({})},
            centeredSlides: {type: Boolean, default: false},
        },
        data() {
            return {
                swiper: null,
            }
        },
        computed: {
            isIOS() {
                return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            }
        },
        mounted() {
            let options = {
                direction: this.direction,
                mousewheel: this.mousewheel,
                keyboard: this.keyboard,
                preventClicks: this.preventClicks,
                preventClicksPropagation: this.preventClicksPropagation,
                preloadImages: this.preloadImages,
                lazy: this.lazy,
                autoplay: this.autoplay,
                slidesPerView: this.slidesPerView,
                speed: this.speed,
                loop: this.loop,
                initialSlide: this.initialSlide,
                roundLengths: this.roundLengths,
                spaceBetween: this.spaceBetween,
                navigation: this.navigation,
                pagination: this.pagination,
                breakpoints: this.breakpoints,
                observer: true,
                observeParents: true,
                centeredSlides: this.centeredSlides,
                on: {
                    init: () => {
                        let storiesTgpSwiper = document.getElementById('stories-tgp-swiper');
                        if (storiesTgpSwiper !== null) {
                            localStorage.removeItem('storiesVolume');
                        }
                    },
                    slideNextTransitionStart: () => {
                        let storiesTgpSwiper = document.getElementById('stories-tgp-swiper');
                        if (storiesTgpSwiper !== null) {
                            let el = document.getElementsByClassName('swiper-slide-prev');
                            let video = el[0].getElementsByClassName('story-video');
                            video[0].pause();
                        }
                    },
                    slidePrevTransitionStart: () => {
                        let storiesTgpSwiper = document.getElementById('stories-tgp-swiper');
                        if (storiesTgpSwiper !== null) {
                            let el = document.getElementsByClassName('swiper-slide-next');
                            let video = el[0].getElementsByClassName('story-video');
                            video[0].pause();
                        }
                    },
                    transitionEnd: () => {
                        let storiesTgpSwiper = document.getElementById('stories-tgp-swiper');

                        if (storiesTgpSwiper !== null) {
                            let el = document.querySelector('.swiper-slide-active');
                            let video = el.querySelector('.story-video');
                            let isVideoPlaying = !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
                            let volume = localStorage.getItem('storiesVolume');
                            let playButton = document.getElementById('story-play-button');
                            // let viewError = document.getElementById('story-error');

                            setTimeout(() => {
                                if (isVideoPlaying) {
                                    // viewError.innerHTML += '<div>' + 'error: ' + error +'</div>';
                                    if (volume === 'yes') {
                                        if (!this.isIOS) {
                                            video.muted = false;
                                        } else {
                                            document.getElementById('reset-to-mute-stories').click();
                                        }
                                    }
                                } else {
                                    let playPromise = video.play();
                                    if (playPromise !== undefined) {
                                        playPromise.then(_ => {
                                            if (volume === 'no' || this.isIOS) {
                                                video.muted = true;
                                                document.getElementById('reset-to-mute-stories').click();
                                            } else if (volume === 'yes' && !this.isIOS) {
                                                video.muted = false;
                                            }
                                            playButton.style.display = 'none';
                                        }).catch(error => {
                                            playButton.style.display = 'block';
                                        });
                                    }
                                }
                            }, 50);

                            // Auto Redirect
                            // let slides = document.getElementsByClassName('stories-swiper-slide');
                            // let activeSlideIndex = el.querySelector('.story').getAttribute('data-story-box');
                            //
                            // if (parseInt(slides.length - 1) === parseInt(activeSlideIndex)) {
                            //     setTimeout(() => {
                            //         location.replace(el.querySelector('.story-fake').getAttribute('href'));
                            //     }, video.duration * 1000);
                            // }
                        }
                    }
                },
            };

            this.swiper = new Swiper(this.$refs.container, options);

            // Listen for signal to reset carousel
            this.$parent.$on('carousel-first-slide', () => {
                this.swiper.destroy();
                this.swiper = new Swiper(this.$refs.container, options);
            });
        },
        beforeDestroy() {
            this.swiper && this.swiper.destroy();
        }
    }
</script>
